import {
    OPENTOK_REQUEST_FAILED, OPENTOK_REQUEST_SUCCEEDED, RECORDING_START_SUCCEEDED, RECORDING_STOP_SUCCEEDED, OPENTOK_REQUESTED, PERMISSIONS_SET
} from '../constants'
import fetch from 'isomorphic-fetch'



export const handleError = error => (dispatch, getState) => {

    dispatch({ type: OPENTOK_REQUEST_FAILED, payload: { error: true, errorMsg: error } })
}

export const startRecording = id => async (dispatch, getState) => {

    const sessionId = getState().opentok.data.sessionId

    const response = await fetch(`${process.env.PUBLIC_URL}/api/Recorder/Start`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({ SessionId: sessionId }),
    })
        .then(res => res.json())
        .catch(err => console.log('err: ', err));

    dispatch({ type: RECORDING_START_SUCCEEDED, payload: response })
}
export const stopRecording = () => async (dispatch, getState) => {
    const sessionId = getState().opentok.data.sessionId
    const archiveId = getState().recording.id


    const response = await fetch(`${process.env.PUBLIC_URL}/api/Recorder/Stop`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({ SessionId: sessionId, ArchiveId: archiveId }),
    })
        .then(res => res.json())
        .catch(err => console.log('err: ', err));

    dispatch({ type: RECORDING_STOP_SUCCEEDED, payload: response })

}

export const requestOpentok = () => async (dispatch, getState) => {
    dispatch({ type: OPENTOK_REQUESTED, payload: { requesting: true } })
    const opentokSession = await fetch(`${process.env.PUBLIC_URL}/api/Recorder/Get`)


        .then(res => res.json())

        .catch(err => dispatch({ type: OPENTOK_REQUEST_FAILED, payload: { requesting: false, isError: true, errorMsg: "Failed to establish recording connection." } }))

    dispatch({ type: OPENTOK_REQUEST_SUCCEEDED, payload: { data: opentokSession, requesting: false } })
}




